import { AvatarDropdown as CoreAvatarDropdown, useSession } from '@zhiyue/core';
import { Avatar } from 'antd';
import { BizAppConfig } from 'config/application.manifest';
import React from 'react';
import { getAvatarDisplayName, getAvatarFallbackText } from '@/utils/avatar';

const AvatarDropdown: React.FC = () => {
  const { currentUser } = useSession();
  const displayName = getAvatarDisplayName(
    currentUser?.nickname,
    currentUser?.name,
    currentUser?.username,
  );
  const fallbackText = getAvatarFallbackText(
    currentUser?.nickname,
    currentUser?.name,
    currentUser?.username,
  );

  return (
    <CoreAvatarDropdown
      personalCenterUrl={BizAppConfig.appPersonalCenterUrl}
      workbenchUrl={BizAppConfig.appWorkbenchUrl}
      tenantManagementUrl={BizAppConfig.appTenantManagementUrl}
      openPlatformUrl={BizAppConfig.appOpenPlatformUrl}
    >
      <div
        style={{
          alignItems: 'center',
          cursor: 'pointer',
          display: 'flex',
          gap: 8,
        }}
      >
        <Avatar size={22} src={currentUser?.avatar}>
          {fallbackText}
        </Avatar>
        <span>{displayName}</span>
      </div>
    </CoreAvatarDropdown>
  );
};

export default AvatarDropdown;
